{
  "account": {
    "cantLoadDetails": "Unfortunately we couldn't load the account details at this time. Please try again later.",
    "emptyTokenList": "This account holds no {{token}} tokens.",
    "emptyTransactionList": "There are no transactions on record for this account.",
    "ERC20": "ERC-20",
    "noTokens": "This account holds no tokens",
    "showMore": "+ {{counter}} more",
    "title": "Account",
    "evmTokens": "EVM tokens",
    "tokensListTitle": "{{token}} Tokens",
    "transactionsListTitle": "Account Transactions",
    "totalReceived": "Total Received",
    "totalSent": "Total Sent"
  },
  "activeAccounts": {
    "title": "Active Accounts",
    "tooltip": "{{value, number}} accounts"
  },
  "blocks": {
    "latest": "Latest Blocks"
  },
  "block": {
    "gasUsed": "{{value, number}} | {{percentage, number}}"
  },
  "banner": {
    "buildStaging": "Please note this is an internal launch meant to gather your feedback. Please share your feedback with screenshots through this from: ",
    "buildPreview": "Please note this is an experimental build of Oasis Explorer and that data that is shown might be incorrect."
  },
  "clipboard": {
    "label": "Copy to clipboard",
    "success": "Copied!"
  },
  "coinGeckoReferral": "Data from <CoinGeckoLink>CoinGecko</CoinGeckoLink>",
  "common": {
    "age": "Age",
    "balance": "Balance",
    "block": "Block",
    "bytes": "{{value, number}}",
    "cancel": "Cancel",
    "createdAt": "Created at",
    "data": "Data",
    "emerald": "Emerald",
    "cipher": "Cipher",
    "consensus": "Consensus",
    "eth": "ETH",
    "ethHash": "ETH hash",
    "failed": "Failed",
    "fiatValue": "Fiat value",
    "fiatValueInUSD": "{{value, currency}}",
    "fill": "Fill",
    "formattedBlockTimestamp": "{{timestamp, dateTime}} ({{distance}})",
    "formattedDateTime": "{{timestamp, dateTime}}",
    "from": "From",
    "gasUsed": "Gas used",
    "gasLimit": "Gas limit",
    "hash": "Hash",
    "height": "Height",
    "hide": "Hide",
    "loadMore": "Load more",
    "lessThanAmount": "< {{value}} {{ticker}}",
    "logs": "Logs",
    "missing": "n/a",
    "name": "Name",
    "oasis": "Oasis",
    "paratime": "Paratime",
    "select": "Select",
    "size": "Size",
    "sapphire": "Sapphire",
    "show": "Show",
    "smartContract": "Smart Contract",
    "smartContract_short": "Contract",
    "success": "Success",
    "status": "Status",
    "ticker": "Ticker",
    "timestamp": "Timestamp",
    "to": "To",
    "totalSent": "Total Sent",
    "transactions": "Transactions",
    "transactionAbbreviation": "Txs",
    "txnFee": "Txn Fee",
    "type": "Type",
    "unknown": "Unknown",
    "value": "Value",
    "valueInToken": "{{value}} {{ticker}}",
    "roundedValueInToken": "{{value}}… {{ticker}}",
    "viewAll": "View all",
    "paraTimeOnline": "ParaTime Online",
    "paraTimeOutOfDate": "ParaTime Out of date",
    "mainnet": "Mainnet",
    "testnet": "Testnet",
    "valuePair": "{{value, number}}"
  },
  "contract": {
    "title": "Contract"
  },
  "nodes": {
    "title": "Active nodes",
    "unknown": "Consensus layer indexer is not caught up with the latest blocks. The number of active nodes is unknown.",
    "tooltip": "Blockchain nodes are authorized devices that track the distributed ledger and serve as communication hubs in the network.",
    "value": "{{value, number}}"
  },
  "errors": {
    "code": "error code",
    "error": "Error",
    "unknown": "Unknown error",
    "unsupportedLayer": "Unsupported layer",
    "unsupportedNetwork": "Unsupported network",
    "invalidAddress": "Invalid address",
    "invalidBlockHeight": "Invalid block height",
    "invalidPageNumber": "Invalid page number",
    "invalidTxHash": "Invalid transaction hash",
    "notFoundBlockHeight": "Block not found",
    "notFoundTx": "Transaction not found",
    "validateURL": "Please validate provided URL",
    "validateURLOrGoToFirstTab": "Please check the URL or load the first tab.",
    "invalidUrl": "Invalid URL"
  },
  "footer": {
    "mobileTitle": "OPF",
    "title": "Oasis Protocol Foundation",
    "version": "Version: <ReleaseLink>{{version}}</ReleaseLink> (commit: <CommitLink>{{sha}}</CommitLink>) built at {{buildTime}}"
  },
  "learningMaterials": {
    "emerald": {
      "header": "What is the Emerald network?",
      "description": "The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility."
    },
    "sapphire": {
      "header": "What is the Sapphire network?",
      "description": "The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    },
    "header": "Learning materials",
    "token": {
      "header": "Token Metrics and Distribution",
      "description": "Rose is the currency powering the Oasis network."
    },
    "transfer": {
      "header": "How to Transfer ROSE into a ParaTime?",
      "description": "Rose is the currency powering the {{layer}} network."
    }
  },
  "pageTitle": "Oasis Explorer",
  "pageHeader": {
    "ribbon": "You are viewing {{network}} data"
  },
  "pagination": {
    "first": "First",
    "last": "Last"
  },
  "rosePrice": {
    "header": "ROSE Price"
  },
  "social": {
    "description": "Be part of the community and stay in the loop on everything Oasis",
    "discord": "Discord",
    "header": "Join us",
    "reddit": "Reddit",
    "telegram": "Telegram",
    "twitter": "Twitter",
    "youtube": "Youtube"
  },
  "tableLayoutButton": {
    "changeView": "Change view"
  },
  "tokens": {
    "holdersCount": "Holders count",
    "holdersCount_short": "Holders",
    "supply": "Supply",
    "title": "Tokens"
  },
  "totalTransactions": {
    "header": "Total Transactions",
    "tooltip": "{{value, number}} total transactions"
  },
  "transactions": {
    "encryption": {
      "dataNonce": "Data Nonce",
      "encryptedData": "Data (encrypted)",
      "encryptedResult": "Result (encrypted)",
      "format": "Format",
      "publicKey": "Public Key",
      "resultNonce": "Result Nonce"
    },
    "latest": "Latest Transactions",
    "method": {
      "unavailable": "Malformed transaction, method unavailable",
      "unknown": "Unknown: {{method}}",
      "accounts": {
        "transfer": "Transfer"
      },
      "consensus": {
        "deposit": "Consensus Deposit",
        "withdraw": "Consensus Withdraw"
      },
      "evm": {
        "call": "Contract Call",
        "create": "Contract Creation"
      }
    }
  },
  "transaction": {
    "header": "Transaction",
    "warningMultipleTransactionsSameHash": "Please make sure you're looking at the right transaction. There is more than one transaction with this hash, which is extremely rare. We are showing the most recent successful one.",
    "tooltips": {
      "txTooltipEth": "Ethereum hash for the transaction",
      "senderTooltipEth": "Ethereum address for the sender",
      "recipientTooltipEth": "Ethereum address for the recipient",
      "txTooltipOasis": "Oasis hash for the transaction",
      "senderTooltipOasis": "Oasis address for the sender",
      "recipientTooltipOasis": "Oasis address for the recipient",
      "txTooltipHashUnavailable": "Hash not available in selected address format",
      "txEncrypted": "This transaction is encrypted.",
      "txNotEncrypted": "This transaction is <strong>not</strong> encrypted.",
      "senderTooltipUnavailable": "Sender not available in selected address format",
      "recipientTooltipUnavailable": "Recipient not available in selected address format"
    }
  },
  "transactionEvent": {
    "cantLoadEvents": "Unfortunately we couldn't load the list of events. Please try again later.",
    "accountsburn": "Tokens burnt",
    "accountsmint": "Tokens minted",
    "accountstransfer": "Transfer",
    "consensusDeposit": "Deposit from consensus",
    "consensusWithdrawal": "Withdrawal to consensus",
    "decoded": "Decoded",
    "evmLog": "EVM log message",
    "gasUsed": "Gas used"
  },
  "transactionStats": {
    "header": "Transactions Per Day",
    "tooltip": "{{value}} tx/day"
  },
  "transactionsTpsChart": {
    "tooltip": "{{value, number}} TPS"
  },
  "select": {
    "placeholder": "Select"
  },
  "chartDuration": {
    "today": "Today",
    "thisWeek": "This week",
    "thisMonth": "This month",
    "allTime": "All time",
    "week": "Week",
    "month": "Month"
  },
  "currentFiatValue": {
    "title": "Current fiat value",
    "explanation": "This figure is calculated using the current rate. The value at the time of transaction might have been different."
  },
  "paraTimeSnapshot": {
    "header": "{{ paratime }} Snapshot"
  },
  "paraTimePicker": {
    "chainId": "Chain ID:",
    "decimal": "Decimal: {{ id }}",
    "comingSoon": "(coming soon)",
    "hex": "Hex: {{ id }}",
    "less": "Show Less",
    "more": "Show More",
    "readMore": "Read more about {{ layer }} on {{ network }} in Oasis Docs",
    "rpcHttp": "RPC HTTP endpoint: {{ endpoint }}",
    "rpcWebSockets": "RPC WebSockets endpoint: {{ endpoint }}",
    "selected": "(currently active)",
    "toggleNetworkMenu": "Toggle networks menu",
    "viewNetworks": "View Networks",
    "viewParaTimes": "View ParaTimes",
    "mainnet": {
      "emerald": "The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility.",
      "sapphire": "The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    },
    "testnet": {
      "emerald": "The Testnet of the EVM Compatible ParaTime providing a smart contract development environment.",
      "sapphire": "The Testnet of the official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    }
  },
  "home": {
    "apiOffline": "Our {{ target }} API is offline. We’re trying to reconnect",
    "userOffline": "You are offline. We’re trying to reconnect",
    "runtimeOutOfDate": "We don't have fully up-to-date data about our {{ target }}. The data displayed here might be out of date.",
    "runtimeOutOfDateSince": "The last update we have about our {{ target }} is from {{ lastUpdate }}. The data displayed here might be out of date.",
    "blocks": "Blocks",
    "exploreBtnText": "Explore Oasis",
    "txn": "Txn",
    "zoomOutBtnText": "Zoom out",
    "helpScreen": {
      "navigate": "Navigate using your finger",
      "pinch": "Pinch to zoom in and out",
      "tap": "Tap to view info",
      "getStarted": "Get Started",
      "infoIconAria": "Toggle info screen"
    },
    "tooltip": {
      "comingSoonAria": "Coming soon...",
      "coming": "Coming soon",
      "online": "Online",
      "openParatime": "Open ParaTime",
      "sapphireParaTimeDesc": "Confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility",
      "emeraldParaTimeDesc": "EVM Compatible ParaTime providing smart contract environment with EVM compatibility.",
      "cipherParaTimeDesc": "The Cipher ParaTime is a Confidential ParaTime for executing Wasm smart contracts.",
      "discoverMore": "Discover more",
      "consensusDesc": "Our scalable, high-throughput, secure, proof-of-stake consensus layer run by a decentralized set of validator nodes.",
      "close": "Close"
    },
    "selectNetwork": "Selected net",
    "selectNetworkAria": "Toggle network selector"
  },
  "search": {
    "placeholder": "Address, Block, Contract, Txn Hash, Transaction ID, etc",
    "mobilePlaceholder": "Search Address, Block, Txn, etc",
    "noResults": {
      "header": "No results found",
      "scopeHeader": "No results found on {{scope}}",
      "description": "Please try another search query <OptionalBreak>or <HomeLink>explore Oasis</HomeLink></OptionalBreak>"
    },
    "otherResults": {
      "clickToShowThem": "We found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.",
      "clickToShowMore": "We also found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.",
      "clickToHide": "The results from other <strong>Networks</strong> are shown below. Click to hide those results."
    },
    "results": {
      "accounts": {
        "title": "Accounts",
        "viewLink": "View Account"
      },
      "blocks": {
        "title": "Blocks",
        "viewLink": "View Block"
      },
      "transactions": {
        "title": "Transactions",
        "viewLink": "View Transaction"
      },
      "count_one": "1 result",
      "count_other": "{{ count }} results",
      "moreCount_one": "1 more result",
      "moreCount_other": "{{ count }} more results"
    },
    "searchBtnText": "Search",
    "searchSuggestions": "Not sure what to look for? Try out a search: <OptionalBreak><BlockLink><BlockIcon/> Block</BlockLink>, <TransactionLink><TransactionIcon/> Transaction</TransactionLink>, <AccountLink><AccountIcon/> Address</AccountLink></OptionalBreak>",
    "sectionHeader": "Results on {{ scope }}"
  }
}
